module.exports = __webpack_public_path__ + "static/media/04B2.5345a13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/04B2.png
// module id = 270
// module chunks = 0